import React from 'react';
import { Link } from 'react-router-dom';
// import ReactLoading from 'react-loading';
import { connect } from 'react-redux';
// import { this.props.history } from 'react-router';
import { bindActionCreators } from 'redux';
import * as specialistActions from '../../actions/specialistActions';
import { ToastContainer, toast } from 'react-toastify';
// import Pagination from "react-js-pagination";
// import * as SVGICONS from '../../images/img/images';
import Moment from 'react-moment';
// import BigCalendar from 'react-big-calendar';
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import moment from 'moment';
// import BigCalendarCSS from 'react-big-calendar/lib/css/react-big-calendar.css';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as appointmentActions from '../../actions/appointmentActions';
import * as gapiAction from '../../actions/gapiActions';
import EventDetails from '../sitemanagement/eventDetails';
import * as constant from '../../constants/constant';
// import momentZ from 'moment-timezone'
import $ from "jquery";
import './block.css'
import * as dashboardActions from "../../actions/dashboardActions";
import BlockAvailability from './BlockAvailability';
import Bl from './Bl';
import { blockingTimeArray, REASONOFBLOCKING, blockingMonth } from './timeSLot';
import CreateAppointment from './createAppointment';
import './calendar.css'
const monthNames = ["January", "February", "March", "April", "May", "June",
	"July", "August", "September", "October", "November", "December"
];
// let userToken = localStorage.getItem('token');
// let specialistId = localStorage.getItem('userId');

class Myevents extends React.Component {
	constructor(props, context) {
		super(props, context);
		var todayDate = moment.utc(new Date());
		var convertDate = new Date(moment(todayDate).local());
		var currenthour = moment(todayDate).local().format("HH")
		var currentmin = moment(todayDate).local().format("mm")
		this.state = {
			appointmentList: [],
			token: '',
			specialistId: '',
			sortColumnName: '',
			appointments: [],
			dayAppointments: [],
			eventDetails: false,
			logoutButton: false,
			blockAvailability: false,
			flag: 1,
			activePage: 1,
			count: 10,
			appointmentDate: convertDate,
			currenthour: currenthour,
			currentmin: currentmin,
			blockingForTheMonth: [],
			reason: REASONOFBLOCKING[0],
			editTabClicked: false,
			openCreateAppointment: false,
			isDetailFetchedLoading: true
		};
		this.getEventStartDate = this.getEventStartDate.bind(this)
		this.getEventEndDate = this.getEventEndDate.bind(this)
		this.deleteAppointment = this.deleteAppointment.bind(this)
		this.handleSelectEvent = this.handleSelectEvent.bind(this)
		this.hideEventDetailsModal = this.hideEventDetailsModal.bind(this)
		this.onLogoutclick = this.onLogoutclick.bind(this);
		this.toggle = this.toggle.bind(this)

		this._logout = this._logout.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);


	}

	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}

	toggle() {
		var windowWidth = $(window).width();
		if (windowWidth < 768) {
			$("body").toggleClass("sidebar-open");
		} else {
			$("body").toggleClass("sidebar-collapse");
		}
	}
	onLogoutclick(data) {
		if (this.state.logoutButton == false) {
			this.setState({
				logoutButton: true
			});
		}
		else {
			this.setState({
				logoutButton: false
			});
		}
	}
	componentWillMount() {

		//  ;
		let userToken = localStorage.getItem('token');
		let specialistId = localStorage.getItem('userId');
		let settingsObj = {
			token: userToken,
			doctorId: specialistId,
			today: new Date(moment().startOf('day')),
			todayEnd: new Date(moment().endOf('day')),
		};
		// let obj = {
		// 	userToken : userToken, specialistId: specialistId
		// };
		// this.props.actions.getSpecialistBlocksList(obj);
		this.props.actions.getAppointmentsForMonth(settingsObj);
		this.props.actions.getAppointmentsForDay(settingsObj);
		let obj = {
			userToken: userToken,
			specialistId: specialistId,
			userlocation: moment.tz.guess()
		};
        this.props.actions.getSpecialistInfoForAppointment({ specialistId });
		this.props.actions.getSpecialistBlocksList(obj);
		// $('body').on('click', 'button.fc-next-button', (e) => {
		// 	// 
		// 	// props.actions.getAppointmentsForMonth(settingsObj);
		// 	this.setState({blockingForTheMonth: []})
		// 	//do something

		// 	
		// });

	}
	removeDuplicates = (originalArray, prop) => {
		var newArray = [];
		var lookupObject = {};

		for (var i in originalArray) {
			lookupObject[originalArray[i][prop]] = originalArray[i];
		}

		for (i in lookupObject) {
			newArray.push(lookupObject[i]);
		}
		return newArray;
	}

	componentWillReceiveProps(nextProps) {

		if (this.state.appointments == 0 || this.state.blockingForTheMonth.length !== 0) {

			this.setState({
				appointments: nextProps.appointments,
				dayAppointments: nextProps.dayappointments
			}, () => {
				if (nextProps.specialistBlockings && nextProps.specialistBlockings.length != 0) {

					var appointmentWithBlocks = this.state.appointments.concat(nextProps.specialistBlockings);
					
					// let filetedApp = this.removeDuplicates(appointmentWithBlocks, "title");
					let filetedApp2 = this.removeDuplicates(appointmentWithBlocks, "start");
					this.setState({
						appointments: filetedApp2,
						blockingForTheMonth: nextProps.specialistBlockings
						// dayAppointments: nextProps.dayappointments
					})
				}
			})
		}
		if (nextProps.specialistDetailForAppointment) {
			this.setState({
				isDetailFetchedLoading: false
			})
		}
		// if (nextProps.dayappointments.length != 0) {
		// 	this.setState({
		// 		dayAppointments: nextProps.dayappointments
		// 	})
		// }
		if (nextProps.dayappointments) {
			this.setState({
				dayAppointments: nextProps.dayappointments.length > 0 ? nextProps.dayappointments : []
			})
		}

		if (nextProps.gapi.urlToRedirect) {
			window.location.href = nextProps.gapi.urlToRedirect
		}


	}

	getEventStartDate() {
		return moment(this.state.appointments.start);
	}

	getEventEndDate() {
		return moment(this.state.appointments.end);
	}

	deleteAppointment(data) {

		// var firstName = data.patientId[0].userName.split(" ")[0][0].toUpperCase() + data.patientId[0].userName.split(" ")[0].substring(1)
		// var lastName = data.patientId[0].userName.split(" ")[1][0].toUpperCase() + data.patientId[0].userName.split(" ")[1].substring(1)
		var patientName = data.patientId[0].userName
		//  firstName + ' ' + lastName
		let nowDiffFromAppointment = /* Math.abs( */(new Date(data.appointmentDateUTC) - new Date())/36e5;
		if (nowDiffFromAppointment > 2) {
			confirmAlert({
				title: 'Confirm',
				message: 'Do you wish to cancel the appointment with ' + patientName + '?',
				buttons: [
					{
						label: 'Yes',
						onClick: () => {
							let userToken = localStorage.getItem('token');
							let specialistId = localStorage.getItem('userId');

							let settingsObj = {
								token: userToken,
								doctorId: specialistId
							};
							let appointmentObj = {
								// token: userToken,
								appointmentId: data._id,
								flag: this.state.flag,
								count: this.state.count,
								page: this.state.activePage,
								patientId: data.patientId,
								settingsObj,
								userType: 'Specialist'
							};
							this.props.appointmentactions.deleteAppointment(appointmentObj, this.props);

							this.props.actions.getAppointmentsForMonth(settingsObj);
							this.props.actions.getAppointmentsForDay(settingsObj);
						}
					},
					{
						label: 'No',
						onClick: () => {
							this.props.history.push('/specialist/my-calendar');
							let userToken = localStorage.getItem('token');
							let specialistId = localStorage.getItem('userId');

							let settingsObj = {
								token: userToken,
								doctorId: specialistId
							};
							this.props.actions.getAppointmentsForMonth(settingsObj);
							this.props.actions.getAppointmentsForDay(settingsObj);
						}
					}
				]
			})
		}else {
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui disclaimer_appointement'>
						<a  style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>
	
							<h1>Error</h1>
							{/* <p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p> */}
							<span> You can cancel an appointment only 2 hours prior to appointment time</span>
							<div className="bottomBtn text-center"><button type="button"  onClick={onClose}	 className="btn btn-warning btn-lg">Ok</button></div>
						</div>
					)
				}
			})
		}
	}

	handleSelectEvent(event, target) {
		let eventDialog = event.event;
		
		let newEvent = {
			desc: eventDialog.title,
			title: eventDialog.title,
			start: eventDialog.start,
			end: eventDialog.end,
			reason: eventDialog.extendedProps.reason,
			extendedProps: eventDialog.extendedProps
			// slot1: ,
			// slot2: 
		}
		this.setState({
			eventDetails: true,
			eventData: newEvent
		})
	}

	hideEventDetailsModal() {
		this.setState({
			eventDetails: false
		})
	}


	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	syncCalendar = () => {
		this.props.gapiAction.getGapiAuth();/* .then((result) => {
			if (result && result.redirectUrl) {
				this.notificationsService.notify("info", "You will be redirected to Google website for authentication. Please wait...")
				window.location.href = result.redirectUrl;
			}
		}).catch((err) => {
			this.notificationsService.notify('error', this._translate.instant(err.json().message));
		}); */
	}
	unSyncCalendar = () => {
		let bodyData = {
			code: "",
			action: 'REVOKE'
		}
		this.props.gapiAction.putGapiToken(bodyData);
	}

	blockAvailability = () => {
		this.setState({ blockAvailability: true })

	}
	
	createAppointment = () => {

		this.setState({ openCreateAppointment: true })
	}

	createTicket = () => {
		this.props.actions.createTicket({ createTicket: "#4521152" })
	}
	blocktheseAvailability = () => {
		let obj = {
			// startDate: new Date(),
			// // endDate: '',
			// timingBlocked: ["6:30 PM-7:00 PM", "8:30 PM-9:00 PM"],
			// reason: "third party appointment",
			// noOfRecursion: 5,
			// daysBlocked: ["sunday", "thursday"],
			id: "dsfsdf",
			weekly: true
			// availableId: 

		}
		let objDay = {
			startDate: new Date(),
			endDate: '2019-11-22T20:27:58.372Z',
			timingBlocked: ["6:30 PM-7:00 PM", "8:30 PM-9:00 PM"],
			reason: "third party appointment",
			noOfRecursion: 5,
			// daysBlocked: ["sunday",  "thursday"],
			// availableId: 

		}
		let monthlyObj = {
			startDate: new Date("2020-07-15T21:53:15.263Z"),
			// endDate: '2021-11-22T20:27:58.372Z',
			// timingBlocked: ["5:00 PM-5:30 PM", "1:00 PM-1:30 PM"],
			reason: "third party appointment",
			noOfRecursion: 6,
		}
		// this.props.appointmentactions.weeklyBlockAvailability(obj, this.props)
		// this.props.appointmentactions.dailyBlockAvailability(objDay, this.props);
		this.props.appointmentactions.monthlyBlockAvailability(monthlyObj, this.props);
		// this.props.appointmentactions.updateWeeklyBlockAvailability(obj, this.props);
	}
	recurrenceDaily = () => {
		this.setState({
			blockAvailability: false,
			recurrenceDaily: true,
		})
	}

	changeReasonForBlocking = (reasonData) => {

		let reason = [reasonData];
		this.setState({ reason })
	}

	calculateAMPM(time) {
		let hours = parseInt(time.slice(0, time.lastIndexOf(":")));
		let minutes = time.slice(time.lastIndexOf(":") + 1);
		
		if (hours == 0) return `12:${minutes} AM`;
		else if (hours == 12) return `12:${minutes} PM`
		else if (hours > 12) return `${hours - 12}:${minutes} PM`
		else return `${hours}:${minutes} AM`
	}

	cloneBlockingEvent = (event) => {

		var userlocation = moment.tz.guess();
		let selectedEvent = event.event;
		let eventDetails = selectedEvent.extendedProps;
		if (eventDetails.type == 'blocking') {
			let changedDate = new Date(selectedEvent.start).getDate();
			let changedYear = new Date(selectedEvent.start).getFullYear();
			let changedMonth = monthNames[new Date(selectedEvent.start).getMonth()];
			let changedMonthName = new Date(selectedEvent.start).getMonth();

			if (changedDate < new Date().getDate() && changedMonthName <= new Date().getMonth()
				&& changedYear <= new Date().getFullYear()) {

				let userToken = localStorage.getItem('token');
				let specialistId = localStorage.getItem('userId');
				let obj = {
					userToken: userToken,
					specialistId: specialistId,
					userlocation
				};
				this.props.actions.getSpecialistBlocksList(obj);
			} else {
				confirmAlert({
					title: 'Confirm',
					message: `Do you really want to create blocking for ${changedDate} of ${changedMonth}`,
					buttons: [
						{
							label: 'Yes',
							onClick: () => {
								
								var selDate = moment.utc(eventDetails.checkappointmentDate);
								var convertedDate = new Date(moment(selDate).local());

								var selStartDate = moment.utc(selectedEvent.start);
								var convertedStartDate = new Date(moment(selStartDate).local());

								var selEndDate = moment.utc(selectedEvent.end);
								var convertedEndDate = new Date(moment(selEndDate).local());

								let blockingDate = convertedStartDate,
									startTime = `${this.calculateAMPM(eventDetails.slot1)}`,
									endTime = `${this.calculateAMPM(eventDetails.slot2)}`,
									dateToBlock = changedDate,
									endDate = convertedEndDate,
									reason = eventDetails.reason;

								let finalBlockingObj = {
									blockingDate,
									startTime,
									endTime,
									reason,
									dateToBlock,
									noOfRecursion: 0,
									startTiming: selectedEvent.start,
									endTiming: selectedEvent.end,
									//   monthToBlock,
									endDate,
									cloningEvent: true,
									userlocation,
									exclude: true,
									excludeId: eventDetails._id,
									excludeDate: convertedDate,
									recurrence: eventDetails.recurrence
								}
								// 
								// return;
								this.props.appointmentactions.yearlyBlockAvailability(finalBlockingObj, this.props)
								// 
								// if (data == 1)
								// this.props.gapiAction.putGapiToken(bodyData, this.props);
								// if (data == 2)
								// 	this.props.gapiAction.putOutlookToken(bodyData, this.props)
							}
						},
						{
							label: 'No',
							onClick: () => {
								let userToken = localStorage.getItem('token');
								let specialistId = localStorage.getItem('userId');
								let obj = {
									userToken: userToken,
									specialistId: specialistId,
									userlocation

								};
								this.props.actions.getSpecialistBlocksList(obj);
							}
						}
					]
				});
			}

		}
	}

	closeEditDetailAndOpenEditBlockingModal = (event) => {
		
		let eventProp = event.extendedProps
		let editProps = {};
		editProps.startTime = {
			value: `${this.calculateAMPM(eventProp.slot1)}`,
			label: `${this.calculateAMPM(eventProp.slot1)}`,
		}
		editProps.endTime = {
			value: `${this.calculateAMPM(eventProp.slot2)}`,
			label: `${this.calculateAMPM(eventProp.slot2)}`,
		};
		editProps.recurrence = eventProp.recurrence;
		editProps.startDate = new Date(eventProp.checkappointmentDate);
		editProps.reason = {
			value: eventProp.reason,
			label: eventProp.reason,
		}
		editProps._id = eventProp._id;

		this.setState({
			eventDetails: false,
			// recurrenceDaily: true,
			editTabClicked: true,
			editProps,
			blockAvailability: true
		})
	}


	render() {
		var address = this.state.address;
		var userData = JSON.parse(localStorage.getItem('user'))
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		let userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');

		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else {
				imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png'
			}
			// var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var rowsList = [];
		var dayappointments = this.state.dayAppointments
		dayappointments.forEach(function (item, index) {
			rowsList.push(<li key={index}> <span className="text-capitalize">{item.patientId[0].firstName}</span> @ {moment.parseZone(new Date(item.appointmentDateUTC)).format('hh:mm A') + " " + userlocation}
				<a href="#" className="closeBtn"
					onClick={this.deleteAppointment.bind(this, item)}>
				</a>
			</li>)
		}.bind(this))

		// const localizer = BigCalendar.momentLocalizer(moment)
		// BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))
		var myEventsList = this.state.appointments;
		myEventsList.forEach(function (item, index) {
			if (new Date(item.start + ' ' + item.slot1) != 'Invalid Date') {
				myEventsList[index]['start'] = new Date(moment.parseZone(new Date(item.checkappointmentDate)).format('YYYY-MM-DD') + ' ' + moment.parseZone(new Date(item.checkappointmentDate)).format('HH:mm'))
				myEventsList[index]['slot1'] = moment.parseZone(new Date(item.checkappointmentDate)).format('HH:mm')
				myEventsList[index]['slot2'] = myEventsList[index]['title'] == "Slot Unavailable" ? moment.parseZone(new Date(item.checkAppointmentEndTime)).format('HH:mm')
					: moment.parseZone(new Date(item.checkappointmentDate)).add(30, 'm').format('HH:mm')
				myEventsList[index]['end'] = myEventsList[index]['title'] == 'Slot Unavailable' ? new Date(moment.parseZone(new Date(item.checkAppointmentEndTime)).format('YYYY-MM-DD') + ' ' + moment.parseZone(new Date(item.checkAppointmentEndTime)).format('HH:mm'))
					: new Date(moment.parseZone(new Date(item.checkappointmentDate)).format('YYYY-MM-DD') + ' ' + moment.parseZone(new Date(item.checkappointmentDate)).add(30, 'm').format('HH:mm'))
				myEventsList[index]['color'] = myEventsList[index]['title'] == "Face 2 Face" ? '#00b5e8' : myEventsList[index]['title'] == 'Online' ? '#ff7245' : '#808080'
			}
		})

		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var condition = (((user.userName != undefined || user.gender != undefined) && user.availabilityCount > 0) && user.isVerified == '2')
		// var allViews = Object
		// 	.keys(BigCalendar.Views)
		// 	.map(k => BigCalendar.Views[k])
		var userType = localStorage.getItem('userType');
		return (
			<div>
				<header className="main-header">
					<Link to={condition ? "/specialist/my-appointment" : null} className="logo">
						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt='' /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/logo_er.png')} /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link to="" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link to="" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
												to=""
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
				<div className="content-wrapper">
					<section className="content container-fluid">
						<ToastContainer />
						{this.state.openCreateAppointment ?
						<CreateAppointment {...this.props}
							openBlockAvailability={this.state.openCreateAppointment}
							closeBlockAvailability={() => this.setState({ openCreateAppointment: false, editTabClicked: false })}
							changeReasonForBlocking={this.changeReasonForBlocking}

						/> : null }
						{this.state.blockAvailability ? <BlockAvailability
							{...this.props} recurrenceDaily={this.recurrenceDaily}
							openBlockAvailability={this.state.blockAvailability}
							closeBlockAvailability={() => this.setState({ blockAvailability: false, editTabClicked: false })}
							changeReasonForBlocking={this.changeReasonForBlocking}
							editTabClicked={this.state.editTabClicked}
							editProps={this.state.editProps}
						/> : ''}
						{this.state.recurrenceDaily ? <Bl
							reason={this.state.reason}
							{...this.props} recurrenceDaily={this.recurrenceDaily}
							openBlockAvailability={this.state.recurrenceDaily}
							closeBlockAvailability={() => this.setState({ recurrenceDaily: false, editTabClicked: false })}

						/> : ''}
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs row">
											<li className="col-md-5" style={{marginRight: "90px"}}><a href="#tab_1" data-toggle="tab" className="active show">Calendar</a></li>
											{/* <li ><button type="button" onClick={this.blocktheseAvailability} className="btn btn-primary btn-sm">Create Availability</button></li> */}
											{/* <li style={{ 'float': 'right', width: '242px' }} onClick={this.createTicket}><button type="button" className="btn btn-blockAvail btn-sm"> <img style={{ height: "20px", width: "20px" }} src={require('../../images/lock.svg')} className="" />      create Availability</button></li> */}
											{/* <li style={{ 'float': 'right', width: '242px' }} onClick={this.blockAvailability}><button type="button" className="btn btn-blockAvail btn-sm"> <img style={{ height: "20px", width: "20px" }} src={require('../../images/lock.svg')} className="" />      Block Availability</button></li> */}
										</ul>
										<div className="settingInput calendarMWD">
											<div className="row">
												<div className="col-md-9">
													<div className="tab-content tabother ">
														<div className="row">
															<div className="col-md-12">
																{this.state.eventDetails ?
																	<EventDetails openModal={this.state.eventDetails}
																		hideEventDetailsModal={this.hideEventDetailsModal}
																		eventData={this.state.eventData}
																		closeEditDetailAndOpenEditBlockingModal={this.closeEditDetailAndOpenEditBlockingModal}
																	/>
																	: ''
																}
																<div id="calendar" >
																	<FullCalendar
																		defaultView="dayGridMonth"
																		plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
																		header={{
																			left: 'prev,next today',
																			center: 'title',
																			right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
																		}}
																		select={(start, end, allDay) => {
																		}}
																		eventClick={(calEvent, jsEvent, view) => {
																			this.handleSelectEvent(calEvent);

																		}}
																		eventMouseEnter={(calEvent) => {
																			// this.handleSelectEvent(calEvent);

																			// <div><Link href="#" className="tooltip-custom fadeEffect tisymtomhover" data-title="Documents"></Link></div>
																		}}
																		// onClick=
																		//   events={myEventsList}
																		displayEventTime={false}
																		selectable={true}
																		editable={true}
																		dragRevertDuration={1}
																		// droppable={true}
																		events={myEventsList}
																		displayEventEnd
																		displayEventTime
																		timeFormat="H"
																		eventTimeFormat={{
																			hour: '2-digit',
																			minute: '2-digit',
																		}}
																		eventDrop={(eventBj, date) => {
																			// $('#calendar').fullCalendar('updateEvent', event);
																			this.cloneBlockingEvent(eventBj);
																			// 
																		}}
																		drop={(date, jsEvent, ui, resourceId) => {

																		}}
																	// draggable

																	/>

																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="col-md-3 active">
													<div className="calender-sidebar">
													<div className="action-buttons">
														<button 
															type="button" 
															onClick={this.createAppointment} 
															disabled={this.state.isDetailFetchedLoading} 
															className="btn btn-square  btn-block"> 
															Create Appointment
														</button>
														<button 
															type="button"  
															onClick={this.blockAvailability} 
															className="btn btn-square  btn-block"> 
															Block Availability
														</button>
													</div>
													<div className="tab-content tabother searchSpe collapResults col-grow">
														<div className="tab-pane active todayAppo" >
															<h2> Today's Appointments</h2>
															{/* <button onClick={this.syncCalendar}>
																Sync To Calendar
															</button>
															<button onClick={this.unSyncCalendar}>
																UnSync From Calendar
															</button> */}
															<ul>
																{rowsList && rowsList.length > 0 ? rowsList : <li>No Appointments</li>}
															</ul>

														</div>
													</div>
													</div>
												</div>
											</div>
										</div></div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		appointments: state.specialist.appointments,
		dayappointments: state.specialist.dayappointments,
		// specialistDetail: state.specialist.specialistDetail,
		specialistBlockings: state.specialist.specialistBlockings,
		specialistDetailForAppointment: state.specialist.specialistDetailForAppointment,
		gapi: state.gapi,
	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {

	return {
		appointmentactions: bindActionCreators(appointmentActions, dispatch),
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch),
		gapiAction: bindActionCreators(gapiAction, dispatch),

	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Myevents);



